import { useNavigate } from 'react-router-dom';


import {Alert, AlertTitle, Box, Button, Chip, CircularProgress, IconButton,
    RadioGroup, Radio, FormControlLabel,
    Snackbar,
    Stack, Tooltip, Typography} from '@mui/material';

import Dialog from '@mui/material/Dialog';

import LoadingButton from '@mui/lab/LoadingButton';
import { useParams } from "react-router-dom";

import { useState, useEffect, useRef, } from 'react';
import { createTheme } from '@mui/material/styles';

import {HrefSelector} from "../components/hrefSelector";

import NearestStoreFilesGrid from '../components/nearestStoreFilesGrid';

import { Icon as Iconify } from '@iconify/react';
import axios from 'axios';
import { lionIcons } from '../components/helpersIcons';
import { GetFilterDefFromMetadata}  from '../components/helpers';

import TemplateEditor from '../components/templateEditor';

import {LionNumberInput} from '../components/lionNumberInput';
import { LabelManager } from '../components/labelManager';
import {HtmlTooltip} from '../components/helpersComponents';
import {NearestStoreSnippetHtmlViewer}  from '../components/snippetHtmlViewer';


import { CcStepper2} from "../commonComponents/stepper"
import {ccColorDarkTeal, ccColorTeal, lionObjectsColors}  from "../components/helpersStyles";
import {CcButton, FileSelector, InputText, InputNumber, LionListbox} from "../commonComponents/inputFields"
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../commonComponents/styledTexts';

import { getErrorListFromYupError, getErrorMessage, snippetDataValidationSchemaNearestStore } from '../components/helperErrors'

import { InfoToolTip } from '../commonComponents/generalComponents';
import { SizeControl } from '../commonComponents/ccMap';

export function NearestStoreElementManager(props) {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )
  templateMetadata: mandatory to pass to see previews

  onChange: returns all the snippet info
  */

  const initialState = {snippetId: 0, snippetName: '', snippetDesc: '', 
  labels: [{labelId: 0, labelName: ''}], href: '',
  snippetTypeId: 1,
  filters: [], orderBy: [],
  dataConnectionId: 0, templateId: 0, dataConnectionInfo: {},
  };
  
  
  const [snippetInfo, setSnippetInfo] = useState(initialState);
  const [popupLabelManagerValue, setPopupLabelManagerValue] = useState({snippetId: 0, data: []});
  const [snippetPreviewImages, setSnippetPreviewImages] = useState({1: {state: 'empty'}}); // Dictionary keys are pos 1, 2 etc... state can be: 'empty', 'loading' or 'loaded' 
  //const [templateMetadata, setTemplateMetadata] = useState(undefined);



  useEffect(() => {
    //console.log(props.snippetInfo)
    if (props.snippetInfo) {
      setSnippetInfo({...props.snippetInfo})
      if (props.snippetInfo.labels && props.snippetInfo.labels.length > 0) {
        //prepare an object that the label manager can use
        const labels = {snippetId: 0, data: props.snippetInfo.labels}
        setPopupLabelManagerValue(labels)
      }
    }

  }, [props.snippetInfo])

  const handleChange = (propName, propValue) => {
    const newSnippetInfo = {...snippetInfo, [propName]: propValue}
    setSnippetInfo(newSnippetInfo);
    if (props.onChange) props.onChange(newSnippetInfo)
  }
  const handleLabelChanges = (lbls) => {
    const newSnippetInfo = {...snippetInfo, labels: lbls}
    setSnippetInfo(newSnippetInfo);
    if (props.onChange) props.onChange(newSnippetInfo)
      // console.log(newSnippetInfo)
  }
  const handleSnippetSettingsChange = (propName, propValue) => {
    const newSnippetSettings = {...snippetInfo.snippetSettings, [propName]: propValue}
    const newSnippetInfo = {...snippetInfo, snippetSettings: newSnippetSettings}
    setSnippetInfo(newSnippetInfo);
    if (props.onChange) props.onChange(newSnippetInfo)
  }
  const updateTestLinks = (link) => {
    // if images are not 'loaded' we do nothing
    if (snippetPreviewImages[1].state !== 'loaded') return;
   
    // we find the link and add it to test in the UI
    const newSnippetPreviewImages = {}
    const regex = "\\$\\{(.*?)\\}"
    const matches = [...link.matchAll(regex)];
    
    Object.keys(snippetPreviewImages).forEach(key => {
      let testLink = link;
      matches.forEach(m => {
        testLink = testLink.replaceAll(m[0], snippetPreviewImages[key].dataRow[m[1]])
      })
      newSnippetPreviewImages[key] = {...snippetPreviewImages[key], href: testLink}
    })
    setSnippetPreviewImages(newSnippetPreviewImages)
  
  }
              
      
  return <div className='mt-4 flex justify-center items-center'>
  <div className='w-[660px] flex flex-col gap-y-4'>
    <InputText displayName="Name"
          value={snippetInfo.snippetName}      
          onChange={(val) => {handleChange('snippetName', val);}}
          error={getErrorMessage(props.validationErrorsList, 'snippetName')}
    />
    <InputText displayName="Description"
          value={snippetInfo.snippetDesc}      
          onChange={(val) => {handleChange('snippetDesc', val);}}
          error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
    />

      <LabelManager data={popupLabelManagerValue}
              compact
              onChange={handleLabelChanges}
        />

      <div className='flex flex-row items-center gap-x-8'>
         <div className='flex flex-row items-center cursor-pointer' onClick={() => {handleSnippetSettingsChange('hrefMode', 'directions')}}>
          <Radio
              checked={snippetInfo.snippetSettings?.hrefMode === 'directions'}
              onChange={() => handleSnippetSettingsChange('hrefMode', 'directions')}
              value="useEmailCover"
              name="radio-coverType"
              inputProps={{ 'aria-label': 'A' }}
              sx={{
                '&.Mui-checked': {
                  color: ccColorTeal,
                },
              }}
            />
          <div className=''>Generate Directions</div>
        </div>
         <div className='flex flex-row items-center cursor-pointer' onClick={() => {handleSnippetSettingsChange('hrefMode', 'static')}}>
          <Radio
              checked={snippetInfo.snippetSettings?.hrefMode === 'static'}
              onChange={() => handleSnippetSettingsChange('hrefMode', 'static')}
              value="useEmailCover"
              name="radio-coverType"
              inputProps={{ 'aria-label': 'A' }}
              sx={{
                '&.Mui-checked': {
                  color: ccColorTeal,
                },
              }}
            />
          <div className=''>Use a link</div>
        </div>
      </div>

      {snippetInfo.snippetSettings?.hrefMode === 'static' &&
        <HrefSelector href={snippetInfo.snippetSettings?.href} fields={props.availableFieldsForHref}
                    onChange={(link) => {handleSnippetSettingsChange('href', link);}}
                    error={getErrorMessage(props.validationErrorsList, 'href') === undefined ? false : true}
                    helperText={getErrorMessage(props.validationErrorsList, 'href')}
        
        />
      }

      <div className='flex flex-row items-center gap-x-1'>
        <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
          Fallback image & Href
        </div>
        <InfoToolTip 
                    placement='right'
                    headLine='Background image'
                    message={<div>These will be used when:
                      <ul className='list-disc'>
                        <li className='ml-4 list-item'> it is not possible to find a store match.</li>
                        <li className='ml-4 list-item'>a match is found but the store is beyond the limit distance<sup>(1)</sup></li>
                      </ul> 
                      <div className='mt-2 text-xs text-slate-500'>(1) When using a tag with latitude and longitude</div>
                      </div>}
                  />

      </div>
      <div className='flex flex-row gap-x-2 items-center'>
        <FileSelector noDeleteButton
          text="Upload"
          onChange={(dataURL) => handleSnippetSettingsChange('fallbackImage', dataURL)}
        />
        {snippetInfo.snippetSettings?.fallbackImage.length > 0 && <div className='flex flex-row gap-x-1'>
                    <div className='bg-slate-200 rounded p-4 mt-2 max-w-[380px] max-h-[230px] flex justify-center'>
                      <div className='relative flex justify-center' >
                          <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={snippetInfo.snippetSettings.fallbackImage} />                              
                      </div>
                    </div>
                    <IconButton sx={{width: '48px', height: '48px'}}
                      onClick={() => handleSnippetSettingsChange('fallbackImage', '')}
                    ><Iconify icon={lionIcons.Icon_Actions_Cancel} /></IconButton>
                </div>                          
        }
        {getErrorMessage(props.validationErrorsList, 'fallbackImage') && <div className='text-sm text-red-600'>
          {getErrorMessage(props.validationErrorsList, 'fallbackImage')}
        </div>      
        }
      </div>
      <InputText displayName="Href"
            value={snippetInfo.snippetSettings?.fallbackHref}
            onChange={(link) => {handleSnippetSettingsChange('fallbackHref', link);}}
            error={getErrorMessage(props.validationErrorsList, 'fallbackHref')}
      />


      <div className='w-72'>
        <SizeControl
          value={snippetInfo.snippetSettings?.maxDistance}
          title='Fallback limit distance'
          unit='Km'
          min={3}
          max={50}
          onChange={(distance) => handleSnippetSettingsChange('maxDistance', distance)}
        />
      </div>

   </div>


  </div>


}

export default function NearestStoreWorkFlow(props) {


const initialState = {snippetId: 0, snippetName: '', snippetDesc: '', 
                   labels: [{labelId: 0, labelName: ''}], href: '',
                   snippetTypeId: 1,
                   filters: [], orderBy: [],
                   snippetSettings: {fallbackImage: '', fallbackHref: '', maxDistance: 3, hrefMode: 'static', href: ''},
                   dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};


const routeParams = useParams();
const [workflowDataConnectionId, setWorkflowDataConnectionId] = useState(null);
const [workflowTemplatePreviewImages, setWorkflowTemplatePreviewImages] = useState(null); // set 1 time only. it contains info to get all preview images url for CA templates. It is passed to SnippetCAEditor as a prop


//const [availableFilters, setAvailableFilters] = useState([]);
//const [availableFieldsForOrderBy, setAvailableFieldsForOrderBy] = useState([]);
//const [availableFieldsForHref, setAvailableFieldsForHref] = useState([]);
const availableFieldsForHref = ['storeId', 'storeName', 'address1', 'address2', 'city', 'country', 'latitude', 'longitude', 'custom1', 'custom2', 'custom3' ]


const [activeStep, setActiveStep] = useState(0);
const [snippetInfo, setSnippetInfo] = useState(initialState);
const [submitLoading, setSubmitLoading] = useState(false);
//const [showTemplateInfoForId, setShowTemplateInfoForId] = useState(0);
const [templateDataConnectionMetadata, setTemplateDataConnectionMetadata] = useState({}); // dictionary {templateId: {dataTypeInMetadata: true, filters: filters}}
// templateMetadata: every time user selects a template we need to check for its feed's metadata so that we can populate the filters and order by combos..              
const [templatesMetadata, setTemplatesMetadata] = useState({}); // dictionary {templateId: {metadata: ''}}

const [showSuccessMsg, setShowSuccessMsg] = useState(false);
const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
const [showErrorMsg, setShowErrorMsg] = useState(false);
const [showLoader, setShowLoader] = useState(false);
const [snackBarClipboardOpen, setSnackBarClipboardOpen] = useState(false);

const [preEditorProps, setPreEditorProps] = useState({});
const [templateId, setTemplateId] = useState(undefined);
const [templateMetadata, setTemplateMetadata] = useState(undefined);
const [workflowNumSnippetsToCreate, setWorkflowNumSnippetsToCreate] = useState(1);

const [activeErrorList, setActiveErrorList] = useState([]);

const navigate = useNavigate();



// load data for edit mode -----
const getSnippetInfo = async (snippetId) => {
   try {
         let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
         const response = await axios.get(url);
          setSnippetInfo({...response.data, snippetSettings: JSON.parse(response.data.snippetSettings)});
          if (response.data.dataConnectionId !== undefined) {
            //const dataTypeInMetadata = response.data.dataConnectionInfo.feedType === 'CATALOG';
            //const filters = GetFilterDefFromMetadata(JSON.parse(response.data.dataConnectionInfo.metadata), dataTypeInMetadata);
            //setAvailableFilters(filters);
            //setAvailableFieldsForOrderBy(filters.map(f => ({fieldName: f.conditionName, dataType: f.dataType})))
            //setAvailableFieldsForHref(filters.map(f => (f.conditionName)))
            setWorkflowDataConnectionId(response.data.dataConnectionId)
          }
          url = `${process.env.REACT_APP_LION_API_URL}/Snippets/templateMetadata/${snippetId}`;
         const responseTemplate = await axios.get(url);
          setTemplateMetadata(responseTemplate.data)

       // setCurrentTemplateId(response.data.templateId);
      } catch (error) {
     console.log(error);
   }
 }

const getDataConnectionInfo = async (dataConnectionId) => {
 try {
       const url = `${process.env.REACT_APP_LION_API_URL}/Feeds/info/${dataConnectionId}`;
       const response = await axios.get(url);
     
       const dataTypeInMetadata = response.data.feedType === 'CATALOG';
       const filters = GetFilterDefFromMetadata(JSON.parse(response.data.metadata), dataTypeInMetadata);
       //setAvailableFilters(filters);
       //setAvailableFieldsForOrderBy(filters.map(f => ({fieldName: f.conditionName, dataType: f.dataType})))
       //setAvailableFieldsForHref(filters.map(f => (f.conditionName)))

       const newTemplateDataConnectionMetadata = {...templateDataConnectionMetadata, [dataConnectionId]:{'dataTypeInMetadata': dataTypeInMetadata, 'filters': filters }}
       setTemplateDataConnectionMetadata(newTemplateDataConnectionMetadata);
       // console.log(newTemplateDataConnectionMetadata)
     
 } catch (error) {
   console.log(error);
 }
}
const getTemplateMetadata = async (templateId) => {
  if (Object.prototype.hasOwnProperty.call(templatesMetadata, templateId)) {
    // console.log('already loaded');
    return;
  }

  try {
        const url = `${process.env.REACT_APP_LION_API_URL}/Templates/info/${templateId}`;
        const response = await axios.get(url);
      
 
        const newTemplatesMetadata = {...templatesMetadata, [templateId]:{'metadata': response.data }}
        setTemplatesMetadata(newTemplatesMetadata);
        console.log(newTemplatesMetadata)
      
  } catch (error) {
    console.log(error);
  }
 }

 
const getTemplatePreviewImagesInfo = async (preselectId) => {
    try {
          const url = `${process.env.REACT_APP_LION_API_URL}/Templates/previewImages`;
          const response = await axios.get(url);
          setWorkflowTemplatePreviewImages(response.data);
          if (preselectId !== undefined) setCurrentTemplateId(preselectId);
    } catch (error) {
      console.log(error);
    }
  }
  

useEffect(() => {
 if (routeParams.snippetId === undefined) {
           //console.log('New');
        }
       else {
         getSnippetInfo(routeParams.snippetId);
        }
}, []);

useEffect(() => {
    if (workflowTemplatePreviewImages == null) getTemplatePreviewImagesInfo();
}, [])

useEffect(() => {
  // this is necessary for the edit. 
  // when editing we don't have some objects defined and we need to run "setCurrentTemplateId"
  // in order to have a consistent state
  if (activeStep === 1 && routeParams.snippetId !== undefined) {
    //setCurrentTemplateId(snippetInfo.templateId);
  }

}, [activeStep])

const moveToNextStep = () => {

   const isValidStep = validateStep(activeStep);
   if (isValidStep) {  
     setActiveStep(activeStep + 1);
   }
 }

 const moveToPreviousStep = () => {        
   setActiveStep(activeStep - 1);
 }

 const validateStep = (numStep) => {
   let isValid = true;
   isValid = true;

   switch(numStep) {
        case 0:
            break;
        case 1:
            break;
        case 2:
            break;
        case 3:
            //validation of this steps needs to happen inside the GeneratorElementManager component

            /*
            if (snippetInfo.snippetName === '') errorVarStep0.errorTemplateName = true;
            else errorVarStep0.errorTemplateName = false;
            if (snippetInfo.snippetDesc === '') errorVarStep0.errorTemplateDescription = true;
            else errorVarStep0.errorTemplateDescription = false;
            if (snippetInfo.href === '') errorVarStep0.errorHref = true;
            else errorVarStep0.errorHref = false;

            if (snippetInfo.snippetName === '' || snippetInfo.snippetDesc === '' || snippetInfo.href === '') isValid = false;
            //setValidationVariables({...validationVariables, '0': errorVarStep0});
            */
            break;
        case 4:
            break;
        default:
           break;
     }
     //console.log(isValid)
     return isValid;
 }

const setCurrentTemplateId = (id) => {
  const newSnippetInfo = {...snippetInfo, templateId: id, filters: [], orderBy: []} // filters and orderBy are reset because if you change a dataConnection you need to work with different fields and previous filter won't be valid
  setSnippetInfo(newSnippetInfo);
  getTemplateMetadata(id)
  const dataConId = getDataConnectionIdOfTemplate(id)
  if (dataConId !== undefined && dataConId !== null) {
    if (Object.prototype.hasOwnProperty.call(templateDataConnectionMetadata, dataConId) === false) {
      getDataConnectionInfo(dataConId)
    }
    else {
      const tInfo = templateDataConnectionMetadata[dataConId];
      const filters = tInfo.filters;
      //setAvailableFilters(filters);
      //setAvailableFieldsForOrderBy(filters.map(f => ({fieldName: f.conditionName, dataType: f.dataType})))
      //setAvailableFieldsForHref(filters.map(f => (f.conditionName)))

    }
  }
}
const getDataConnectionIdOfTemplate = (templateId) => {
    const template = workflowTemplatePreviewImages.find(tInfo => tInfo.templateId === templateId);
    return template.dataConnectionId;
}

/*
const handleChange = (propName, propValue) => {
  const newSnippetInfo = {...snippetInfo, [propName]: propValue}
  setSnippetInfo(newSnippetInfo);
}
*/


const submitData = async () => {
  try {
    snippetDataValidationSchemaNearestStore.validateSync(snippetInfo, {abortEarly: false});
    setActiveErrorList([])
  }
  catch (e) {
    const errorList = getErrorListFromYupError(e)
    setActiveErrorList(errorList)
    console.log(errorList)
    return false;
  }

  setShowLoader(true);
  setSubmitLoading(true);
  setSuccessHtmlMsg('');
  const cleanMetadata = {...templateMetadata, nearestStoreMapImage: ''} //no need to save nearestStoreMapImage on to the server
  const dataToPost = {...snippetInfo, customJSON: JSON.stringify(cleanMetadata), snippetSettings: JSON.stringify(snippetInfo.snippetSettings)}
  console.log(dataToPost)

  try {
  let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/28`;
  if (routeParams.snippetId !== undefined) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/28/${routeParams.snippetId}`;
  // console.log(snippetInfo)
  const response = await axios.post(url, dataToPost);
  setSuccessHtmlMsg(response.data);
  setShowSuccessMsg(true);
  } catch (error) {
  setShowSuccessMsg(false);
  setShowErrorMsg(true);
  console.log(error);
  }
  setShowLoader(false);
  setSubmitLoading(false);
  return true;
}


const copyHtmlCodeToClipboard = (code) => {
setSnackBarClipboardOpen(true);
navigator.clipboard.writeText(code);
}
const handleCloseSnackBarClipboard = () => {
setSnackBarClipboardOpen(false);
}
const SnackBarAction = (
<>
 <IconButton
   size="small"
   aria-label="close"
   color="inherit"
   onClick={handleCloseSnackBarClipboard}
 >
   <Iconify icon={lionIcons.Icon_Actions_Cancel} />
 </IconButton>
</>
);


/*
const handleSaveExitClicked = () => {
  navigate("/ph/generator")
}
*/
const handleNextClicked = (tId, tJson) => {
  setTemplateId(tId)
  setTemplateMetadata(tJson)
  const newSnippetInfo = {...snippetInfo, template: tJson}
  //console.log(newSnippetInfo)
  setSnippetInfo(newSnippetInfo)
  setActiveStep(2);
}
const handleSnippetChange = (newSnippetInfo) => {
  setSnippetInfo(newSnippetInfo)
  try {
    snippetDataValidationSchemaNearestStore.validateSync(newSnippetInfo, {abortEarly: false});
    setActiveErrorList([])
  }
  catch (e) {
    const errorList = getErrorListFromYupError(e)
    setActiveErrorList(errorList)
  }

  //console.log(newSnippetInfo)
}
const handleSubmit = async() => {
  const isValid = await submitData()
  if (isValid) setActiveStep(3);
}

    const [createNewFile, setCreateNewFile] = useState(false)
    const handleFileCreateChange = (info) => {
        //the grid handles everything --> no need to do anything here
        //we use the event to change the display mode of the grid
        setCreateNewFile(false)
    }
    const createNewStoresFile = () => {
        setCreateNewFile(true)
    }
    const handleFileSelected = (row) => {
        setWorkflowDataConnectionId(row.id)
    }

 return <>
 
         <CcStepper2
            steps={[{ name: 'Store file', href: '#' },
                    { name: 'Visual', href: '#' },
                    { name: 'Element', href: '#' },
                    { name: 'Confirm', href: '#' },
                ]}
            currentStepIndex={activeStep}
        />


 { activeStep === 0 && <>
            <div className="mt-6 flex flex-row gap-x-1 items-center">
                <CcSubSectionTitle className="">Stores files</CcSubSectionTitle>
                 <Tooltip title='Upload a new file' placement='right'><IconButton sx={{color: ccColorDarkTeal, }} onClick={createNewStoresFile}><Iconify icon={lionIcons.Icon_Actions_Add} width="32" height="32" /></IconButton></Tooltip>
            </div>

            <div className="h-[460px]">
                <NearestStoreFilesGrid createNew={createNewFile}
                    noActions
                    onRowClick={handleFileSelected}
                    selectedFileId={snippetInfo.dataConnectionId}
                 //onFileChange={handleFileCreateChange}
                  />
            </div>
  </>
 }

      {activeStep === 1 &&
              <TemplateEditor id={templateId} templateMetadata={templateMetadata}
              embeddedInWizard
              noTemplateName
              onPreviousClicked={() => setActiveStep(0)}
              //onSaveExitClicked={handleSaveExitClicked}
              onNextClicked={handleNextClicked}
              buildFromDictionary={{...preEditorProps, dataConnectionId: workflowDataConnectionId}}
              //closingCall={() => {setAddEditMode(false); setTemplateIdToEdit(null)}}
              snippetTypeId={28}

              />
      }


{ activeStep === 2 && <NearestStoreElementManager
                        templateId={templateId}
                        dataConnectionId={workflowDataConnectionId}
                        snippetInfo={snippetInfo}
                        //availableFilters={availableFilters}
                        //availableFieldsForOrderBy={availableFieldsForOrderBy}
                        availableFieldsForHref={availableFieldsForHref}
                        templateMetadata={templateMetadata}
                        onChange={handleSnippetChange}
                        //onNumSnippetsChange={(num) => setWorkflowNumSnippetsToCreate(num)}
                        validationErrorsList={activeErrorList}
                        />

}

{
       activeStep === 3 &&
         <Stack display='flex' justifyContent='center' alignItems='center'>

          {showLoader && <CircularProgress size={64} /> }
           {showSuccessMsg && <Stack spacing={4}><Alert severity="success" sx={{ml:'15%', mr:'15%'}}
                               >
                           <AlertTitle>Success</AlertTitle>
                           <Typography>Element created successfully</Typography>
                         </Alert>
                         <NearestStoreSnippetHtmlViewer
                                    html={successHtmlMsg} />
                         </Stack>}

           {showErrorMsg && <Alert severity="error">
             <AlertTitle>Error</AlertTitle>
             Something went wrong while saving your snippet
           </Alert>}
         </Stack>
   }


{activeStep !== 1 &&
   <Box display="flex" justifyContent="flex-end" sx={{m:1}} >
     {(!showSuccessMsg && !showErrorMsg) && activeStep > 0 && <Button variant="contained" onClick={moveToPreviousStep} sx={{mr:1, backgroundColor: ccColorTeal, ":hover":{backgroundColor: ccColorDarkTeal}}}>Previous</Button>} 
     {(!showSuccessMsg && !showErrorMsg) && activeStep < 2 && <Button sx={{backgroundColor: ccColorTeal, ":hover":{backgroundColor: ccColorDarkTeal}}} variant="contained" onClick={moveToNextStep} 
                                                                    disabled={(workflowDataConnectionId == null)}
                                                                    >Next</Button>}
     {(!showSuccessMsg && !showErrorMsg) && activeStep === 2 && <LoadingButton sx={{backgroundColor: ccColorTeal, ":hover":{backgroundColor: ccColorDarkTeal}}} variant="contained" 
           onClick={handleSubmit} 
           loading={submitLoading} >Submit</LoadingButton>}
     {(showSuccessMsg || showErrorMsg) && <Button variant="contained" href='/ph/nearestStore'>Close</Button>}
 </Box>
}

 <Snackbar
   anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
   open={snackBarClipboardOpen}
   autoHideDuration={1500}
   onClose={handleCloseSnackBarClipboard}
   message="Copied to clipboard"
   action={SnackBarAction}
 />


 </>
}
